import { render, staticRenderFns } from "./OldSurveySecondPSModal.vue?vue&type=template&id=621013ab&scoped=true"
import script from "./OldSurveySecondPSModal.vue?vue&type=script&lang=js"
export * from "./OldSurveySecondPSModal.vue?vue&type=script&lang=js"
import style0 from "./OldSurveySecondPSModal.vue?vue&type=style&index=0&id=621013ab&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "621013ab",
  null
  
)

export default component.exports